import { jsx as _jsx } from "react/jsx-runtime";
import { useI18N } from "@sundae/react-hooks";
import { ErrorFallback as ErrorFallbackBase } from "@sundae/ui-toolkit";
import { useWalletDetails } from "@sundae/wallet-react";
import ErrorDetailsMessage from "../../i18n/components/error/ErrorDetailsMessage/index.js";
import ErrorFallbackMessageAutoSend from "../../i18n/components/error/ErrorFallbackMessage/ErrorFallbackMessageAutoSend.trans.js";
import ErrorFallbackMessage from "../../i18n/components/error/ErrorFallbackMessage/index.js";
import { useProfileAppContext } from "../../stores/index.js";
export const PREVIEW_ERRORS = "https://api.errors.preview.sundaeswap.finance/sundae-rewards/new-report";
export const ERRORS_API_URL = process.env.NODE_ENV === "development"
    ? PREVIEW_ERRORS
    : window.__APP_CONFIG.apiUrls.errors;
const ErrorFallback = ({ error, resetErrorBoundary }) => {
    const { t } = useI18N("error-fallback");
    const { state: { errorReportingEnabled }, } = useProfileAppContext();
    const { details, activeWallet } = useWalletDetails();
    const renderFallbackMessage = () => {
        if (errorReportingEnabled) {
            return _jsx(ErrorFallbackMessageAutoSend, {});
        }
        return _jsx(ErrorFallbackMessage, {});
    };
    return (_jsx("div", { className: "px-6 pb-6 pt-24", children: _jsx(ErrorFallbackBase, { renderFallbackMessage: renderFallbackMessage, renderCollapsibleTrigger: (toggle) => (_jsx(ErrorDetailsMessage, { toggleCollapsible: toggle })), errorReportingEnabled: errorReportingEnabled, activeWallet: activeWallet, walletAddress: details?.mainAddress, error: error, 
            /**
             * @TODO Allow arbitrary values in the report data in UI Toolkit
             */
            // @ts-ignore
            getReportData: async () => {
                return {
                    buildInfo: {
                        ...window.__BUILD_CONFIG,
                        buildAt: new Date(window.__BUILD_CONFIG.buildDate),
                    },
                };
            }, resetErrorBoundary: resetErrorBoundary, errorReportingEndpoint: "", i18n: {
                cancelButtonText: t("dontSend", {
                    ...(errorReportingEnabled && { context: "autoSend" }),
                }),
                confirmButtonText: t("sentReport", {
                    ...(errorReportingEnabled && { context: "autoSend" }),
                }),
                dateHeader: t("date", { ns: "common" }),
                dialogTitle: t("title"),
                errorMessageHeader: t("errorMessage"),
                errorStackHeader: t("errorStack"),
                osHeader: t("os", { ns: "common" }),
                reportIdHeader: t("reportID", { ns: "common" }),
                urlHeader: t("url", { ns: "common" }),
                walletAddressHeader: t("walletAddress"),
                walletInfoHeader: t("wallet", { ns: "glossary" }),
                browserHeader: t("browser", { ns: "common" }),
            } }) }));
};
export default ErrorFallback;
//# sourceMappingURL=ErrorFallback.js.map